import React from "react";
import { NavLink, NavLinkProps } from "react-router-dom";
import useBuildNavLink from "../../hooks/useBuildLink";

export interface CustomNavLinkProps
  extends NavLinkProps,
    React.RefAttributes<HTMLAnchorElement> {
  to: string;
}

function CustomNavLink({ to, ...restProps }: CustomNavLinkProps) {
  const buildNavLink = useBuildNavLink();
  const handleChangeRoute = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.location.href = buildNavLink(to);
  };

  return (
    <NavLink to={buildNavLink(to)} {...restProps} onClick={handleChangeRoute} />
  );
}

export default CustomNavLink;
